import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Clock } from 'lucide-react';
import { api } from '../lib/api';
import { useAuth } from '../lib/auth';
import { formatMoeda } from '@fiodecobre/shared';
import { useAlertaFaixa } from './alertas/AlertasContexto';

interface Resumo { qtd: number; total: string | number; mais_antiga: string | null }

const POLLING_MS = 5 * 60 * 1000;

// Faixa in-system (estilo contas a pagar / divergencia de caixa) pras transferencias "em transito"
// que a gerencia nao validou ha mais de 24h: dinheiro que a operadora entregou e ainda nao entrou
// oficialmente no destino. Igual a faixa de divergencia: NAO some sozinha nem da pra dispensar —
// fica ate o admin/gerente BAIXAR (confirmar o recebimento) na aba Transferencias, porque dinheiro
// em transito nao "se resolve sozinho".
export function AlertaTransferenciasPendentesBanner() {
  const navigate = useNavigate();
  const { usuario } = useAuth();
  const [resumo, setResumo] = useState<Resumo | null>(null);

  const podeVer = usuario && ['admin', 'gerente'].includes(usuario.perfil);

  useEffect(() => {
    if (!podeVer) return;
    let cancelado = false;
    async function tick() {
      try {
        const r = await api.get<Resumo>('/api/caixa/transferencias-pendentes-resumo');
        if (!cancelado) setResumo(r);
      } catch {}
    }
    void tick();
    const id = setInterval(tick, POLLING_MS);
    return () => { cancelado = true; clearInterval(id); };
  }, [podeVer]);

  const ativo = !!(podeVer && resumo && resumo.qtd > 0);
  const recolhido = useAlertaFaixa(
    'transferencias',
    ativo ? { rotulo: 'Repasses', bg: '#f59e0b', borda: '#d97706', qtd: resumo!.qtd } : null,
  );

  if (!ativo || recolhido || !resumo) return null;

  const total = Number(resumo.total);

  return (
    <div
      style={{
        background: '#f59e0b',
        borderLeft: '4px solid #d97706',
        color: '#000',
        padding: '8px 14px',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        fontSize: 13,
        cursor: 'pointer',
      }}
      onClick={() => navigate('/caixa', { state: { aba: 'transferencias' } })}
    >
      <Clock size={16} />
      <span style={{ fontWeight: 600 }}>Repasses aguardando validação há mais de 24h:</span>
      <span>
        {resumo.qtd} {resumo.qtd === 1 ? 'transferência' : 'transferências'}
        {total > 0.005 && <> · {formatMoeda(total)}</>}
      </span>
      <span style={{ marginLeft: 'auto', textDecoration: 'underline' }}>Validar</span>
    </div>
  );
}
